export const AppConstant = {
    company_email: "logicraftinfotech23@gmail.com",
    company_mobile: "+919265442122",
    company_address: "201-C, Balaji Complex, 150 Feet Ring Rd, Mahapuja Dham Chowk, Rajkot, Gujarat, 360005",
    facebook_link: "https://www.facebook.com/people/Logicraft-Infotech/61557318735009/",
    instagram_link: "https://www.instagram.com/logicraft_infotech/",
    whatsApp_link: "https://wa.me/919265442122",

}